import React from 'react';
import { PERFORMANCE_LIFECYCLE_STATUSES } from './performanceRows';

function PerformanceStatusSummaryStrip({ counts = {} }) {
  return (
    <section className="director-card director-status-summary-strip">
      <div className="role-section-header">
        <h2>Scorecard Status</h2>
        <span>Live</span>
      </div>
      <div className="director-status-summary-grid">
        {PERFORMANCE_LIFECYCLE_STATUSES.map((status) => (
          <div className="director-status-summary-card" key={status}>
            <span>{status}</span>
            <strong>{counts[status] || 0}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PerformanceStatusSummaryStrip;
